import { t } from "i18next";
import { TComparaisonFilters } from "../store/reducers/comparaison.reducer";
import { isEmpty } from "lodash";
import dayjs from "dayjs";

export function transformFiltersToArray(filters?: TComparaisonFilters) {
    let data: { tooltip: string, title: string }[] = []

    if (!filters) return data

    if (filters.startDate) {
        data.push({ tooltip: t('riders:startDate'), title: dayjs(filters.startDate).format('DD-MM-YYYY') })
    }

    if (filters.endDate) {
        data.push({ tooltip: t('riders:endDate'), title: dayjs(filters.endDate).format('DD-MM-YYYY') })
    }

    if (!isEmpty(filters.selectedTracks)) {
        filters.selectedTracks.forEach(track => {
            data.push({ tooltip: t('editTrainingForm:trackName:label'), title: track.display_name })
        })
    }

    if (!isEmpty(filters.selectedTrainingTypes)) {
        filters.selectedTrainingTypes.forEach(tp => {
            data.push({ tooltip: t('editTrainingForm:trainingType:label'), title: tp.display_name })
        })
    }

    return data
}